/**
 * ExternalPlatformAccount — aligned's `external_platform_accounts` collection.
 * One doc per expert; drives the Partner-access screen's derivation of what
 * external-platform capabilities the expert currently has.
 *
 * Dates are stored/read as ISO strings (aligned's `@UTCDateTimeConverter`).
 */

export interface ExternalPlatformAccount {
  id: string;
  alignedEmail: string;
  firebaseId: string;
  expertId: string;
  expertName: string;
  expertEmail: string;
  mailgunRouteId: string | null;
  mailgunRouteEnabled: boolean;
  metaEnabled: boolean;
  metaProxyEnabled: boolean;
  metaSrtId: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

type Data = Record<string, unknown>;

const str = (v: unknown): string | undefined => (typeof v === 'string' ? v : undefined);
const strOrNull = (v: unknown): string | null => (typeof v === 'string' ? v : null);
const bool = (v: unknown, dflt: boolean): boolean => (typeof v === 'boolean' ? v : dflt);

export function mapExternalPlatformAccount(id: string, data: Data): ExternalPlatformAccount {
  return {
    id,
    alignedEmail: str(data.alignedEmail) ?? '',
    firebaseId: str(data.firebaseId) ?? '',
    expertId: str(data.expertId) ?? '',
    expertName: str(data.expertName) ?? '',
    expertEmail: str(data.expertEmail) ?? '',
    mailgunRouteId: strOrNull(data.mailgunRouteId),
    mailgunRouteEnabled: bool(data.mailgunRouteEnabled, false),
    metaEnabled: bool(data.metaEnabled, false),
    metaProxyEnabled: bool(data.metaProxyEnabled, false),
    metaSrtId: strOrNull(data.metaSrtId),
    createdAt: strOrNull(data.createdAt),
    updatedAt: strOrNull(data.updatedAt),
  };
}
